// extracted by mini-css-extract-plugin
export default {"botao":"botao_botao__lTDLV","primary":"botao_primary__2swTU","secondary":"botao_secondary__z9Z4h"};